module.exports = __webpack_public_path__ + "img/t5-i6.9e4bb4fd.svg";